import TaskList from "../../../../Project/allProjectsPage/ProjectsTable/ProjectTasksPage/TaskList";
import BidTab from "./BidTab";
import DrawingBomTab from "./DrawingBom";
import MRQTab from "./MRQTab";
import PoManger from "./PoManager";
import PoReconcile from "./PoReconcile";
import SPIRTab from "./SPIRTab";

export const BOMTabs = (tabType) => [
  {
    label: tabType === "pnid" ? "Tag# Dashboard" : "BOM Dashboard",
    panel: <DrawingBomTab />,
  },
  {
    label: "MRQ",
    panel: <MRQTab />,
  },
  {
    label: "Bid Evaluation",
    panel: <BidTab />,
  },
  {
    label: "PO Manager",
    panel: <PoManger />,
  },
  {
    label: "Reconcile",
    panel: <PoReconcile />,
  },
  {
    label: "SPIR",
    panel: <SPIRTab />,
  },
  // {
  //   label: "Task List",
  //   panel: (
  //     <TaskList
  //       catList={[
  //         { title: "MRQ", docNumber: "003" },
  //         { title: "MRV", docNumber: "003" },
  //         { title: "SRV", docNumber: "003" },
  //         // { title: "Material Procurement", docNumber: "003" },
  //         // { title: "Material Procurement", docNumber: "003" },
  //         // { title: "MRV", docNumber: "004" },
  //       ]}
  //     />
  //   ),
  // },
];
